<template>
	<header
		:class="['levelbar', { 'levelbar__award-category': pageData.category }]"
	>
		<h1 class="levelbar__title">{{ pageData.heading }}</h1>
		<div class="levelbar__side--right">
			<router-link
				v-if="pageData.id === 'SplashManage'"
				to="/manage/splash-submit"
				class="btn levelbar__side__button"
				>스플래시 이미지 등록</router-link
			>
			<template v-else-if="pageData.id === 'PushManage'">
				<template v-if="$store.state.env.NODE_ENV === 'development'">
					<button
						class="btn levelbar__side__button"
						v-text="'자동푸쉬(출석) 테스트'"
						@click="testPush"
					/>
					<button
						class="btn levelbar__side__button"
						v-text="'자동푸쉬(Q&A) 테스트'"
						@click="testPush('qna')"
					/>
				</template>
				<router-link
					to="/manage/push-send"
					class="btn levelbar__side__button"
					>푸시 등록</router-link
				>
			</template>
			<router-link
				v-else-if="pageData.id === 'Message'"
				to="/operation/message-register"
				class="btn levelbar__side__button"
				>메시지 등록</router-link
			>
			<router-link
				v-else-if="pageData.id === 'InitPopup'"
				to="/manage/init-popup/register"
				class="btn levelbar__side__button"
				>팝업 배너 등록
			</router-link>
			<router-link
				v-else-if="pageData.id === 'ProductList'"
				to="/product/product-register"
				class="btn levelbar__side__button"
				>제품 등록</router-link
			>
			<router-link
				v-else-if="pageData.id === 'WebviewManage'"
				to="/operation/webview/register"
				class="btn levelbar__side__button"
				>웹뷰 화면 등록</router-link
			>
			<router-link
				v-else-if="pageData.id === 'EditorProductList'"
				to="/product/editor-product/register"
				class="btn levelbar__side__button"
				>추천제품 등록</router-link
			>
			<router-link
				v-else-if="pageData.id === 'BrandRecommendManage'"
				to="/advertisement/brand-recommend-register"
				class="btn levelbar__side__button"
				>추천브랜드 등록</router-link
			>
			<router-link
				v-else-if="pageData.id === 'ManageRankingModule'"
				to="/product/add-ranking-module"
				class="btn levelbar__side__button"
				>랭킹모듈 등록</router-link
			>
			<router-link
				v-else-if="pageData.id === 'PurchaseLedger'"
				to="/intranet/purchase-register"
				class="btn levelbar__side__button"
				>매입 매출 신규등록</router-link
			>
			<router-link
				v-else-if="pageData.id === 'CustomerManage'"
				to="/intranet/customer-register"
				class="btn levelbar__side__button"
				>거래처 신규등록</router-link
			>
			<template
				v-else-if="
					[
						'ReviewAnalysis',
						'EventReview',
						'CategoryReview',
						'ReviewWordStats',
						'Dictionary',
						'Factor',
						'ProductRank',
					].includes(pageData.id)
				"
			>
				<p class="levelbar__side__desc">
					주의!!! 글로우픽 분석 페이지 데이터들은 실 운영
					데이터입니다. 개발 데이터가 따로 없으니 유의하세요.
				</p>
				<router-link
					to="/review/review-analysis"
					class="btn levelbar__side__button"
					>리뷰 분석</router-link
				>
				<router-link
					to="/review/event-review"
					class="btn levelbar__side__button"
					>평가단 리뷰</router-link
				>
				<router-link
					to="/review/category-review"
					class="btn levelbar__side__button"
					>카테고리 리뷰</router-link
				>
				<router-link
					to="/review/review-word-stats"
					class="btn levelbar__side__button"
					>리뷰단어 통계</router-link
				>
				<router-link
					to="/review/dictionary"
					class="btn levelbar__side__button"
					>사전</router-link
				>
				<router-link
					to="/review/factor"
					class="btn levelbar__side__button"
					>성분</router-link
				>
				<router-link
					to="/review/product-rank"
					class="btn levelbar__side__button"
					>제품랭킹</router-link
				>
			</template>
			<button
				v-else-if="adminLevel === 1 && pageData.id === 'AdminList'"
				class="btn levelbar__side__button"
				@click="activeModal('AdminModify', '신규 관리자 추가')"
			>
				계정추가
			</button>
			<router-link
				v-else-if="pageData.id === 'SearchDefaultText'"
				to="/manage/add-search-default-text"
				class="btn levelbar__side__button"
				>등록</router-link
			>
			<router-link
				v-else-if="pageData.id === 'IngredientList'"
				to="/product/ingredient-management"
				target="_blank"
				class="btn levelbar__side__button"
				>성분등록하기</router-link
			>
			<button
				v-else-if="pageData.id === 'DepartmentManage'"
				class="btn levelbar__side__button"
				@click="activeModal('DepartmentAssign', '', { type: 'add' })"
			>
				부서추가
			</button>
			<router-link
				v-else-if="pageData.id === 'MainBannerManage'"
				to="/advertisement/main-banner-register"
				class="btn levelbar__side__button"
				>메인배너 등록</router-link
			>
			<router-link
				v-else-if="pageData.id === 'MainLineBanner'"
				to="/advertisement/line-banner-register"
				class="btn levelbar__side__button"
				>홈DA 등록</router-link
			>
			<router-link
				v-else-if="pageData.id === 'EventLineBanner'"
				to="/advertisement/event-line-register"
				class="btn levelbar__side__button"
				>이벤트 띠배너 등록</router-link
			>
			<router-link
				v-else-if="pageData.id === 'ProductLineBanner'"
				to="/advertisement/product-line-register"
				class="btn levelbar__side__button"
				>제품상세 띠배너 등록</router-link
			>
			<button
				v-if="pageData.id === 'ProductInquiry'"
				class="btn levelbar__side__button"
				@click="callMainFunction('openViewExpression')"
			>
				제품 표현식
			</button>
			<button
				v-if="pageData.id === 'ProductInquiry'"
				class="btn levelbar__side__button"
				@click="callMainFunction('analyzeAi')"
			>
				AI 분석 다운로드
			</button>
			<button
				v-if="pageData.id === 'ProductInquiry'"
				class="btn levelbar__side__button"
				@click="callMainFunction('openViewLogDialog')"
			>
				날짜별 조회수
			</button>
			<router-link
				v-if="pageData.id === 'ProductInquiry'"
				:to="`/advertisement/ad?search_field=idProduct&idProduct=${pageData.idProduct}`"
				class="btn levelbar__side__button"
				>이벤트광고 이력</router-link
			>
			<button
				v-if="pageData.id === 'ProductInquiry'"
				class="btn levelbar__side__button"
				@click="
					activeModal('ProductChangeHistory', '제품 변경이력', {
						idProduct: pageData.idProduct,
					})
				"
			>
				변경이력 조회
			</button>
			<router-link
				v-if="pageData.id === 'EventModify'"
				:to="`/advertisement/ad?search_field=divisionId&divisionId=${pageData.idEvent}&division=내부&divisionType=이벤트`"
				class="btn levelbar__side__button"
				>이벤트광고 이력</router-link
			>
			<template v-if="pageData.id === 'EventStampList'">
				<button
					v-if="hasNew"
					:disabled="true"
					class="btn"
					v-text="`${nextMonth} 출석체크 등록`"
				/>
				<router-link
					v-else
					:to="`/event/stamp/${nextMonth}/submit`"
					class="btn levelbar__side__button"
					>{{ nextMonth }} 출석체크 등록</router-link
				>
			</template>
			<router-link
				v-if="pageData.id === 'EventsList'"
				to="/events/old-events"
				class="btn levelbar__side__button"
				>(구) 이벤트 리스트</router-link
			>
			<router-link
				v-if="pageData.id === 'CastList'"
				to="/cast/submit"
				class="btn levelbar__side__button"
				>캐스트 등록</router-link
			>
			<router-link
				v-if="pageData.id === 'Analytics'"
				:to="`/operation/category-analytics`"
				class="btn levelbar__side__button"
				>카테고리별 제품수/리뷰수 통계</router-link
			>
			<router-link
				v-if="pageData.id === 'CategroyAnalytics'"
				:to="`/operation/analytics`"
				class="btn levelbar__side__button"
				>통계관리</router-link
			>
			<router-link
				v-if="pageData.id === 'ServiceCheck'"
				:to="`/operation/service-check-register`"
				class="btn levelbar__side__button"
				>서비스 점검 등록</router-link
			>
		</div>
		<div class="levelbar__side--left" v-if="pageData.category">
			<div class="awardCategory">
				<span v-if="pageData.category === 'firstCategory'">
					1차 카테고리</span
				>
				<span v-if="pageData.category === 'secondCategory'">
					2차 카테고리</span
				>
				<span v-if="pageData.category === 'thirdCategory'">
					3차 카테고리</span
				>
				<span v-if="pageData.category === 'mappingProduct'">
					제품 맵핑</span
				>
			</div>
		</div>
	</header>
</template>
<script>
	import { mapState, mapGetters } from 'vuex';

	export default {
		name: 'Levelbar',
		computed: {
			...mapState({
				adminLevel: state => state.login.adminLevel,
				hasNew: state => state.stamp.hasNew,
			}),
			...mapGetters({
				nextMonth: 'stamp/nextMonth',
			}),
			pageData() {
				return this.$route.params;
			},
		},
		methods: {
			activeModal(id, contsTitle, params) {
				this.$store.commit('modal/toggleModal', {
					id,
					contsTitle,
					params,
				});
			},
			callMainFunction(func_name) {
				this.$parent.$refs.main[func_name]();
			},
			async testPush(type) {
				const url =
					type === 'qna'
						? '/system/fcm/send/qna-auto-push'
						: '/system/fcm/send/stamp-auto-push';
				const { status } = await this.$axiosSupport.post(url);
				if (status === 200) {
					window.location.reload();
				} else {
					alert(`자동푸쉬 테스트 상태코드 ${status}`);
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	.levelbar {
		display: flex;
		padding-bottom: 8px;
		border-bottom: solid 1px #ebebed;
		justify-content: space-between;
		&.levelbar__award-category {
			justify-content: left;
			gap: 5px;
			font-size: 20px;
			color: #898888;
		}
	}

	.levelbar__title {
		height: 30px;
		flex-shrink: 0;
		line-height: 30px;
		color: #303643;
		font-weight: bold;
		font-size: 1.625rem;
	}

	.levelbar__side--right {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		justify-content: flex-end;

		@media (max-width: 768px) {
			flex-direction: column;
			align-items: flex-end;
		}
	}
	.levelbar__side--left {
		span {
			display: inline-block;
			&::before {
				content: '-';
				width: 10px;
				height: 10px;
			}
		}
	}

	.levelbar__side__button {
		margin-left: 10px;

		&:first-child {
			margin-left: 0;
		}

		@media (max-width: 768px) {
			margin: 2px 0 0 0;
		}
	}

	.levelbar__side__desc {
		width: 100%;
		color: $red;
		text-align: right;
		margin-bottom: 12px;
		line-height: 20px;
	}
</style>
